import React, { useState } from "react";

export const MessageContext = React.createContext({showMessage: () => {}});

const defaultProps = {
    isInput: false,
    isOkCancel: false,
    isOpen: false,
    isYesNo: false,
    message: '',
    selectionData: [],
    title: ''
};

export default function MessageProvider({children}) {
    const [inputValue, setInputValue] = useState("");
    const [isInput, setIsInput] = useState(false);
    const [isOkCancel, setIsOkCancel] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const [isYesNo, setIsYesNo] = useState(false);
    const [message, setMessage] = useState('');
    const [resolveMsg, setResolveMsg] = useState(null);
    // selectionData must be an array of objects with id and display properties {id: 1, display: name}
    const [selectionData, setSelectionData] = useState([]);
    const [selectionValue, setSelectionValue] = useState(-1);
    const [title, setTitle] = useState('');

    const onClose = (result) => {
        setIsOpen(false);
        if (resolveMsg) {
            resolveMsg(result);
            setResolveMsg(null);
        }
    };

    const showMessage = (props) => {
        const { title, message, isOkCancel, isYesNo, isInput, selectionData } = {
            ...defaultProps,
            ...props
        };
        setInputValue("");
        setIsInput(isInput);
        setIsOkCancel(isOkCancel);
        setIsOpen(true);
        setIsYesNo(isYesNo);
        setMessage(message);		
        setSelectionData(selectionData);
        setTitle(title);
        return new Promise((resolve) => {
            setResolveMsg(() => resolve);
        });
    };

    return (
        <MessageContext.Provider value={
            {
                showMessage,
                isOpen,
                isYesNo,
                isInput,
                isOkCancel,
                title,
                message,
                inputValue,
                setInputValue,
                selectionData,
                selectionValue,
                setSelectionValue,
                onClose
            }
        }>
            {children}
        </MessageContext.Provider>
    );
};